import styled from "styled-components";
import Typography from "common/Typography/Typography";
import { typography } from "@shared/common/Themes/typography";
import { TypographyProps } from "@shared/common/Typography/Typography";

const Text = styled(Typography)<
  TypographyProps & { $isTwoLinesEllipsis?: boolean }
>`
  ${(p) =>
    p.$isTwoLinesEllipsis &&
    `
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
  `};
`;

Text.defaultProps = {
  as: "p",
  $weight: typography.fontWeights.NORMAL,
  $size: typography.fontSizes.M,
};

export default Text;
